var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0517 2C21.9022 2 27.4656 7.51074 27.5507 14.341C27.6361 21.1968 22.1187 26.8849 15.2633 26.9982C9.51978 27.0932 4.64403 23.3137 3.0784 18.1018C2.72659 16.9308 3.60289 15.7512 4.82564 15.7511L14.7373 15.7502C15.3873 15.7501 15.7129 16.5361 15.2532 16.9957L13.2749 18.9733C12.8356 19.4126 12.7916 20.0976 13.1431 20.5861L13.2749 20.741C13.7143 21.1804 14.3993 21.2243 14.8877 20.8729L15.0427 20.741L20.3999 15.3839C20.8392 14.9446 20.8831 14.2595 20.5316 13.7711L20.3999 13.6162L15.0705 8.28676C14.5812 7.79746 13.7779 7.76564 13.2837 8.2502C12.8362 8.68917 12.7893 9.38005 13.1431 9.8718L13.2749 10.0267L15.2516 12.0028C15.7113 12.4623 15.3858 13.2482 14.7359 13.2483L4.826 13.2486C3.60161 13.2487 2.72695 12.0669 3.0795 10.8944C4.58778 5.87956 9.16067 2.19182 14.622 2.00729L15.0517 2Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/Assign.3f47d365cc63ffe6fb241e8700e2ecb4.svg";
export { ForwardRef as ReactComponent };